var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-container',{attrs:{"modules":['naturalPerson', 'signature'],"required-fields":['naturalPerson.firstName']}})
}
var staticRenderFns = []

export { render, staticRenderFns }